module.exports = __webpack_public_path__ + "static/media/SKonnect-AMS.48e1e10b.png";